const scrollIntoInvalidField = () => {
  const errorElement = document.querySelector('input.is-invalid')
  if (errorElement) {
    const scrollArgs = { behavior: 'smooth', block: 'start', inline: 'nearest' }
    if (typeof errorElement.scrollIntoView === 'function') {
      errorElement.scrollIntoView(scrollArgs)
    }
  }
}

export default scrollIntoInvalidField
